/**
 * Keys, which belong to Coverage Package.
 */
export const coveragePackageKeys = [
    "coverageA",
    "coverageB",
    "coverageC",
    "coverageDLossOfUse",
    "coverageEPremisesLiability",
    "coverageEPersonalLiability",
    "coverageFMedicalPaymentToOthers",
    "deductibles",
    "animalLiability",
    "damageToPropertyOfOthers",
    "fungiWetOrDryRotOrBacteriaProperty",
    "inflationGuard",
    "roofPaymentSchedule",
    "waterDamage",
];
/**
 * Keys, which belong to Extra Coverage, but are stored on Policy Level.
 */
export const policyLevelExtraCoverageKeys = [
    "scheduledPersonalProperty",
    "identityFraud",
];
/**
 * Keys, which belong to Extra Coverage.
 * Those are in order as rendered on the Extra Coverage page.
 */
export const extraCoverageKeys = [
    "mineSubsidence",
    "mineSubsidenceScheduled",
    ...policyLevelExtraCoverageKeys,
    "golfCarts",
    "enhancedCoverage",
    "equipmentBreakdown",
    "tripCollision",
    "earthquake",
    "vacationRental",
    "waterBackupAndSumpOverflow",
    "incidentalFarming",
    "lossAssessment",
    "debrisRemoval",
    "sinkhole",
    "residenceBurglary",
    "buildersRisk",
    "secondaryResidenceLiability",
    "vandalismOrMaliciousMischief",
    "windstormOrHailExclusion",
    "fortifiedRoofUpgrade",
];
/**
 * Names of the deductibles.
 */
export const namesOfDeductibles = [
    "allOtherPerilsDeductible",
    "windHailDeductible",
    "waterDamageDeductible",
];
